import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("/app/app/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/app/app/layouts/empty.vue").then(m => m.default || m)),
  "no-footer": defineAsyncComponent(() => import("/app/app/layouts/no-footer.vue").then(m => m.default || m))
}